import { useMemo } from "react";
import { TransactionSource } from "@snackpass/snackpass-types";
import { Settings2 } from "lucide-react";

import { getDefinedSources } from "#pickers/channel-picker/lib";
import { useOrders } from "../../orders-context";
import { FilterSelect2 } from "src/@/components/ui/filter-select-2";
import { t } from '@lingui/core/macro';

export const OrdersChannelPicker = () => {
    const { channels, setChannels } = useOrders();

    const selectedChannels = useMemo(
        () => new Set(channels as string[]),
        [channels],
    );

    const options = useMemo(() => getDefinedSources(), []);

    return (
        <FilterSelect2
            icon={Settings2}
            title={t`Channel`}
            selectedValues={selectedChannels}
            options={options}
            onOptionSelected={function (value: string): void {
                if (selectedChannels.has(value)) {
                    selectedChannels.delete(value);
                } else {
                    selectedChannels.add(value);
                }
                setChannels(
                    Array.from(selectedChannels) as TransactionSource[],
                );
            }}
        />
    );
};
